module.exports = __webpack_public_path__ + "static/media/4.744e2f29.png";